import { createFileRoute } from '@tanstack/react-router'

import { RootRoute } from '@/pages/auth/route-entries/blocked'

export const Route = createFileRoute('/blocked')({
  component: RootRoute,
})
